<script lang="ts">
  import HeroSection from './HeroSection.svelte';
  import ToolCard from './ToolCard.svelte';
  import type { Route } from '../../stores/router';

  const tools: Array<{
    icon: string; title: string; description: string;
    route: Route; color: string; tags: string[]; disabled?: boolean;
  }> = [
    {
      icon: '🔍', title: 'Campaign Debugger',
      description: 'Debug advertiser issues with timeline, execution traces, and AI-powered analysis',
      route: 'debugger', color: '#EC7211', tags: ['Timeline', 'AI Chat', 'Traces'],
    },
    {
      icon: '📂', title: 'S3 Explorer',
      description: 'Browse agent execution logs, graph traces, and node-level state data',
      route: 's3-explorer', color: '#38BDF8', tags: ['S3', 'Graph Traces', 'JSON'],
    },
    {
      icon: '🗄️', title: 'DynamoDB Viewer',
      description: 'Query CS3 strategies, output cache, and advertiser data tables',
      route: 'ddb-viewer', color: '#A855F7', tags: ['CS3', 'Cache', 'Query'],
    },
    {
      icon: '📜', title: 'Log Explorer',
      description: 'Search and filter CloudWatch logs across all Lambda functions',
      route: 'log-explorer', color: '#34D399', tags: ['CloudWatch', 'Search', 'Tail'],
    },
    {
      icon: '📨', title: 'SQS Monitor',
      description: 'Monitor trigger queue depth and DLQ message counts in real-time',
      route: 'sqs-monitor', color: '#FB7185', tags: ['Queue', 'DLQ', 'Alerts'],
    },
    {
      icon: 'λ', title: 'Lambda Inspector',
      description: 'View Lambda configurations, runtimes, memory, and environment variables',
      route: 'lambda-inspector', color: '#FBBF24', tags: ['Config', 'Runtime', 'Env Vars'],
    },
    {
      icon: '📊', title: 'Health Dashboard',
      description: 'Aggregate health view across all services with real-time status indicators',
      route: 'health-dashboard', color: '#2DD4BF', tags: ['Status', 'Metrics', 'Alarms'],
    },
    {
      icon: '🔄', title: 'Strategy Lifecycle',
      description: 'Track strategy state transitions from GENERATED through ENABLED/DISABLED',
      route: 'strategy-lifecycle', color: '#D4A537', tags: ['CS3', 'States', 'Timeline'],
    },
  ];
</script>

<div class="min-h-screen bg-bg-dark">
  <HeroSection />
  <div class="max-w-[1600px] mx-auto px-6 pb-16">
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {#each tools as tool (tool.route)}
        <ToolCard {...tool} />
      {/each}
    </div>
  </div>
</div>
